import type { AnimationProperties, AnimationsKit } from '../../types';

const name = 'BaseRotate';
const properties: Partial<AnimationProperties> = {};

const supportedDirections: { [key: string]: boolean } = {
  cw: true,
  ccw: true,
  short: true,
};

function animate(
  kit: AnimationsKit,
  elements: HTMLElement[] | HTMLElement | HTMLCollection,
  duration: number = 0,
  delay: number = 0,
  params: any = {},
) {
  const { to, from } = params;
  if (
    to &&
    typeof to.rotation !== 'undefined' &&
    supportedDirections[to.direction]
  ) {
    params.to.rotation = `${to.rotation}_${to.direction}`;
  }
  if (
    from &&
    typeof from.rotation !== 'undefined' &&
    supportedDirections[from.direction]
  ) {
    params.from.rotation = `${from.rotation}_${from.direction}`;
  }

  return kit.engine.tween(elements, { duration, delay, ...params }, [
    'rotation',
  ]);
}

export { name, properties, animate };
